import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { SharedService } from 'src/app/shared/services';
import { MessageService } from 'primeng/api';
import { EmailConfiguration } from '../../models';
import { EmailConfigurationService } from '../../services'; 
import { IGlobalSearchParam } from 'src/app/shared/models/Global-Search.model';
import {MenuItem, LazyLoadEvent,} from 'primeng/api';
import { NgxSpinnerService } from 'ngx-spinner';
import { Table } from 'primeng/table';
import { Router, ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-email-configuration',
  templateUrl: './email-configuration.component.html',
  styleUrls: ['./email-configuration.component.css'],
  providers: [MessageService]
})
export class EmailConfigurationComponent implements OnInit {

  isEmailConfigAdd : boolean = false;
  isEmailConfigEdit : boolean = false;
  emailFromSES:boolean=true;
  emailFromSendGrid:boolean=false;
  buttonLabel: string = "";
  title: string = "";
  emailForm:FormGroup;
  emailConfigurationList;
  emailConfigurationSearchParam:IGlobalSearchParam;
  oldSortField:string = 'createdOn';
   oldSortOrder:string = 'desc';
   sortField:string = 'createdOn';
   sortOrder:string = 'desc';
   appliedFilters:{field:string,matchMode:string,value:string}[]=[];
   pageNo: number =1;
   pageSize: number =10;
   oldPageNo: number =1;
   oldPageSize: number =10;
   totalRecords: number;
   loadEvent: LazyLoadEvent;
   isshowpaginator:boolean=true;
   isSearchLoading: boolean = false;
   loading: boolean = false;
   emailConfigurationSearchSpinner = 'emailConfigurationSearchSpinner';
   filters;
   showFilters:boolean;
   showSorting:boolean;
   filterCondition: { fieldName: string; type: string; }[] =[];
   startSearch: boolean = false;
   selectedGridMenuItem:any = null;
   items: MenuItem[];
   isdisableAdd:boolean=false;
  constructor(
    public datepipe: DatePipe,
    private _fb: FormBuilder,
    public sharedService:SharedService,
    private emailConfigurationService:EmailConfigurationService,
    private spinner: NgxSpinnerService,
    private _router: Router
  ) 
  {
    this.showFilters = false;
    this.showSorting = false;
    this.spinner.show();
    setTimeout(() => {
        this.spinner.hide();
    }, 1000);
   }

  ngOnInit(): void {
    this.checkAdminView();
    this.items = [];
    this.checkEditPermission();
    this.filterCondition=[
      {fieldName:"mailFromId",type:"basic"},
      {fieldName:"smtpUserName",type:"basic"},
      {fieldName:"host",type:"basic"},
      {fieldName:"port",type:"basic"},
      {fieldName:"isActive",type:"basic"},
      {fieldName:"createdBy",type:"basic"},
      {fieldName:"createdOn",type:"date"},
    ];
    this.appliedFilters.push({ field:"globalfilter", matchMode:"equals", value:"0" }) 
    this.getEmailConfigurationList();
    this.InitialSetup();
  }

  InitialSetup(){
    this.emailForm = this._fb.group({
      configId: new FormControl(0,[Validators.required]),
      emailSenderName:new FormControl("",[Validators.required]),
      emailFromAddress: new FormControl("",[Validators.required]),
      smtpUserName: new FormControl("",[Validators.required]),
      smtpPassword: new FormControl("",[Validators.required]),
      smtpHost: new FormControl("",[Validators.required]),
      smtpPort: new FormControl("",[Validators.required]),
      isActive: new FormControl(false,[Validators.required]),
      createdBy: new FormControl(""),
      createdOn: new FormControl(""),
      modifiedBy: new FormControl(""),
      modifiedOn: new FormControl("")
    })
  }

  addEmailConfigurationDetails(){
    this.InitialSetup();
    this.isEmailConfigAdd = true;
    this.isEmailConfigEdit = false;
    this.title = "Email Configuration Add";
    this.buttonLabel = "Save";
  }

  cancel(){
    this.isEmailConfigAdd = false;
    this.isEmailConfigEdit = false;
  }

  getEmailConfigurationList()
   {
     this.emailConfigurationSearchParam = 
        {
          pageNo:this.pageNo,
          pageSize:this.pageSize,
          sortField:this.sortField,
          appliedFilters:this.appliedFilters,
          sortOrder:this.sortOrder
        };
       this.spinner.show(this.emailConfigurationSearchSpinner);
       this.emailConfigurationService.getAllEmailConfiguration(this.emailConfigurationSearchParam).subscribe((data: any) => {
       this.appliedFilters = [];
       this.emailConfigurationList =data;
       this.isshowpaginator=this.emailConfigurationList.length>0?true:false;
       console.log(this.emailConfigurationList);
       this.totalRecords = data[0].totalCount;
       
       if(this.totalRecords==2)
       {
         this.isdisableAdd=true;
       }
       this.spinner.hide(this.emailConfigurationSearchSpinner);
      });
   }

   loademailConfigurationList(event:LazyLoadEvent)
   { 
     this.loadEvent=event;
     if(event.first==0)
     {
       this.pageNo = 1;
     }
     else {
       this.pageNo=(event.first/event.rows)+1;
     }
     this.pageSize=event.rows;
     
     this.pageSize=event.rows;
     
     if((this.oldPageNo != this.pageNo) || (this.oldPageSize != this.pageSize))
     {
     this.getEmailConfigurationList();
     }
     this.oldPageNo = this.pageNo;
     this.oldPageSize = this.pageSize;
     this.filters=event.filters;
     if(this.filters["createdOn"]!= undefined)
     {
     /*if(this.filters["createdOn"][0].matchMode == "date-after")
     {
        this.showAddRuleButton = true;
     }
     else{
       this.showAddRuleButton = false;
     }*/
    }
     this.sortField=event.sortField;
     if(event.sortField === undefined || event.sortField === null)
     {
       this.sortField='createdOn';
     }
     if(event.sortOrder === 1)
     {
     this.sortOrder='desc';
     }
     if(event.sortOrder === -1)
     {
     this.sortOrder='asc';
     }
     if(this.oldSortField !==  this.sortField ||  this.oldSortOrder !== this.sortOrder)
     {
       this.getEmailConfigurationList()
     }
     this.oldSortField = this.sortField;
     this.oldSortOrder = this.sortOrder;
   }
  
  save({value}: {value: EmailConfiguration}){
    console.log(value);
    if(value.configId == 0){
      value.createdBy = 1;
      value.createdOn = new Date();
      this.emailConfigurationService.postEmailConfiguration(value).subscribe(data => {
        this.getEmailConfigurationList();
        this.isEmailConfigAdd = false;
      }, error => {
        console.log(error)
      })
    }else{
      this.emailConfigurationService.updateEmailConfiguration(value.configId, value).subscribe(data => {
        this.getEmailConfigurationList();
        this.isEmailConfigEdit = false;
      }, error => {
        console.log(error);
      })
    }
  }

  applyFilterNew(table: Table){
    this.filters=table.filters;
    this.applyFilter();
  }

  applyFilter()
   {
     console.log(this.filterCondition.length);
     console.log(this.filterCondition);
     console.log(this.filters);
     if (Object.keys(this.filters).length > 1) {
       this.appliedFilters = [];
       for (let i = 0; i < this.filterCondition.length; i++) {
         if (this.filterCondition[i].type == "checkbox") {
           if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
             if (this.filters[this.filterCondition[i].fieldName][0].value == true) {
               this.appliedFilters.push({
                 field: this.filterCondition[i].fieldName,
                 matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                 value: "true"
               })
             }
             else if (this.filters[this.filterCondition[i].fieldName][0].value == false) {
               this.appliedFilters.push({
                 field: this.filterCondition[i].fieldName,
                 matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                 value: "false"
               })
             }
           }
         }
         else if (this.filterCondition[i].type == "basic") {
           console.log("filter type is basic");
           if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
             if (this.filters[this.filterCondition[i].fieldName][0].value !== null) {
               console.log("filter field name is "+[this.filterCondition[i].fieldName][0]);
               this.appliedFilters.push({
                 field: this.filterCondition[i].fieldName,
                 matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                 value: this.filters[this.filterCondition[i].fieldName][0].value
               })
             }
           }
         }
         else if (this.filterCondition[i].type == "date") {
           if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
             for (let j = 0; j <= this.filters[this.filterCondition[i].fieldName].length - 1; j++) {
               if (this.filters[this.filterCondition[i].fieldName][j].value !== null)
                 this.appliedFilters.push({
                   field: this.filterCondition[i].fieldName,
                   matchMode: this.filters[this.filterCondition[i].fieldName][j].matchMode,
                   value: this.datepipe.transform(this.filters[this.filterCondition[i].fieldName][j].value,"MM-dd-yyyy")
                 })
             }
           }
         }
         else if (this.filterCondition[i].type == "numeric") {
           if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
             if (this.filters[this.filterCondition[i].fieldName][0].value !== null)
               this.appliedFilters.push({
                 field: this.filterCondition[i].fieldName,
                 matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                 value: this.filters[this.filterCondition[i].fieldName][0].value
               })
           }
         }
     }
     }
 
     if(this.startSearch == true || this.startSearch == false)
     {
       this.emailConfigurationSearchParam = 
        {
          pageNo:this.pageNo,
          pageSize:this.pageSize,
          sortField:this.sortField,
          appliedFilters:this.appliedFilters,
          sortOrder:this.sortOrder
        };
       this.spinner.show(this.emailConfigurationSearchSpinner);
       this.emailConfigurationService.getAllEmailConfiguration(this.emailConfigurationSearchParam).subscribe((data: any) => {
       this.emailConfigurationList =data;
       this.isshowpaginator=this.emailConfigurationList.length>0?true:false;
       console.log(this.emailConfigurationList);
       this.totalRecords = data[0].totalCount;
       this.spinner.hide(this.emailConfigurationSearchSpinner);
       });
     }
   }

   checkAdminView()
   {
     var result = this.sharedService.checkPermission("Admin_View");
     if(!result)
     this._router.navigateByUrl('/login');
   }

   checkEditPermission() {
    var isAdminAdd = this.sharedService.checkPermission("Admin_Add");
    if (isAdminAdd) {
      var editItem = {
        label: 'Edit',
        icon: 'pi pi-fw pi-pencil',
        command: e => this.editEmailConfigurationDetails(this.selectedGridMenuItem.configId)
      }
      this.items.push(editItem)
    }
  }

   editEmailConfigurationDetails(paramId: number)
   { 
     this.InitialSetup();
     this.isEmailConfigEdit = true;
     this.isEmailConfigAdd = false;
     this.title = "Email Configuration Edit";
     this.buttonLabel = "Update";
     this.emailConfigurationService.getEmailConfigurationById(paramId).subscribe((data:EmailConfiguration) =>{
       this.emailForm.patchValue(data);
     },error => {
       console.log(error)
     })
   }

}
